export default function useBurgerMenu() {
    const headerBurger = document.querySelector('.header__burger');
    const headerMenu = document.querySelector('.header__menu');

    const toggleBurger = () => {
        headerBurger.classList.toggle('header__burger_active');
        headerMenu.classList.toggle('header__menu_show');
    };

    const closeBurger = () => {
        headerBurger.classList.remove('header__burger_active');
        headerMenu.classList.remove('header__menu_show');
    };

    const initBurger = () => {
        if (headerBurger) {
            headerBurger.addEventListener('click', toggleBurger);

            const links = headerMenu.querySelectorAll('a');
            links.forEach(link => {
                link.addEventListener('click', () => {
                    closeBurger();
                });
            });
        }
    };

    return {
        initBurger,
        closeBurger,
    };
}
